import { gql } from 'apollo-angular';

export const ENTITY_TRANSLATION_ROW_FRAGMENT = gql`
fragment EntityTranslationRow on EntityTranslationRow {
    id
    existingLanguages
    fields {
        field
        label
        values {
            languageCode
            value
        }
    }
}
`;

export const TRANSLATE_TEXTS = gql`
mutation TranslateTexts($input: TranslateAIInput!) {
    translateTexts(input: $input) {
        items {
            key
            text
            error {
                message
                type
            }
        }
        errors {
            message
            type
        }
    }
}
`;

export const GET_ENTITY_TRANSLATIONS = gql`
query GetEntityTranslations($input: EntityTranslationInput!) {
    getEntityTranslations(input: $input) {
        items {
            ...EntityTranslationRow
        }
        totalItems
    }
}
${ENTITY_TRANSLATION_ROW_FRAGMENT}
`;
